import React from 'react';
import { IconPropsType } from '../../types';

const UploadImage = (props: IconPropsType) => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 3V7C14.5 7.26522 14.6054 7.51957 14.7929 7.70711C14.9804 7.89464 15.2348 8 15.5 8H19.5" stroke="#0068FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5 21H7.5C6.96957 21 6.46086 20.7893 6.08579 20.4142C5.71071 20.0391 5.5 19.5304 5.5 19V5C5.5 4.46957 5.71071 3.96086 6.08579 3.58579C6.46086 3.21071 6.96957 3 7.5 3H14.5L19.5 8V19C19.5 19.5304 19.2893 20.0391 18.9142 20.4142C18.5391 20.7893 18.0304 21 17.5 21Z" stroke="#0068FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.5 11V17" stroke="#0068FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 14L12.5 11L15.5 14" stroke="#0068FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default UploadImage;
